import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Inject,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import {
  ConfirmationService,
  MessageService,
  PrimeNGConfig,
} from 'primeng/api';
import { filter } from 'rxjs';

import { MetaTagsService } from './services/meta-tags/meta-tags.service';

import { environment } from '../environments/environment';
import { PrimeNGModule } from './primeng.module';
import { MercadoPagoService } from './services/mercado-pago/mercado-pago.service';
import { ConfirmDialogComponent } from './shared/components/confirm-dialog/confirm-dialog.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { HeaderCartCheckoutComponent } from './shared/components/header-cart-checkout/header-cart-checkout.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { LoaderComponent } from './shared/components/loader/loader.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    HeaderCartCheckoutComponent,
    FooterComponent,
    LoaderComponent,
    ConfirmDialogComponent,
    PrimeNGModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [MessageService, ConfirmationService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponent implements OnInit {
  public previousUrl?: string;
  public isCartOrCheckoutPage = false;
  public routeCategory = '';

  constructor(
    private mercadoPagoService: MercadoPagoService,
    private primeNgConfig: PrimeNGConfig,
    private router: Router,
    public metaTagsService: MetaTagsService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        const urlSegments = event.urlAfterRedirects
          .split('/')
          .filter((segment: any) => segment);

        this.routeCategory = urlSegments[0];

        const url = event.urlAfterRedirects;
        this.isCartOrCheckoutPage =
          url.includes('/carrinho') ||
          url.includes('/pagamento') ||
          url.includes('/confirmacao') ||
          url.includes('/orcamento');
      });
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      const initialLoader = document.getElementById('initial-loader');
      if (initialLoader) {
        initialLoader.remove();
      }
    }

    this.primeNgConfig.ripple = true;
    this.primeNgConfig.setTranslation({
      ...this.primeNgConfig.translation,
      aria: {
        ...this.primeNgConfig.translation.aria,
        pageLabel: 'Indicador para a imagem {page}',
        slideNumber: 'Item {slideNumber}',
      },
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects || event.url;

        if (this.previousUrl?.includes('/pagamento')) {
          this.mercadoPagoService.removeScript();
        } else if (url.includes('/pagamento')) {
          this.mercadoPagoService.addScript(environment.mercadoPagoPublicKey);
        }

        this.previousUrl = url;
      }
    });
  }
}
